import api from "../services/authService";

// Partner dashboard (backend: dms_backend/partner_reports, mounted at
// /api/reports/partner/, gated by the reports.partner_dashboard capability).
// Every call takes the same filter object; the backend ignores what it does
// not understand and defaults the window to month-to-date.

const BASE = "/reports/partner";

export const toQuery = (filters = {}) => {
  const params = {};
  if (filters.start) params.start = filters.start;
  if (filters.end) params.end = filters.end;
  if (filters.practiceAreas?.length) params.practice_areas = filters.practiceAreas.join(",");
  if (filters.attorneys?.length) params.attorneys = filters.attorneys.join(",");
  if (filters.includeArchived !== undefined) params.include_archived = filters.includeArchived ? "1" : "0";
  return params;
};

export const fetchOverview = (filters) => api.get(`${BASE}/overview/`, { params: toQuery(filters) });
// One row per practice area — the page's top level. Never a firm total.
// The scorecard is the practice-area picker, so it must list every area:
// the selected area is deliberately not sent (the backend ignores it too).
// It is also always "now" (last complete month, 12-month trend), so the
// page's date window is not sent either; only the attorney filter is.
export const fetchScorecard = (filters) =>
  api.get(`${BASE}/scorecard/`, { params: toQuery({ attorneys: filters.attorneys }) });
export const fetchSignups = (filters) => api.get(`${BASE}/signups/`, { params: toQuery(filters) });
export const fetchConversion = (filters) => api.get(`${BASE}/conversion/`, { params: toQuery(filters) });
export const fetchTimeToMatter = (filters) => api.get(`${BASE}/time-to-matter/`, { params: toQuery(filters) });
export const fetchCaseload = (filters) => api.get(`${BASE}/caseload/`, { params: toQuery(filters) });
export const fetchCosts = (filters) => api.get(`${BASE}/costs/`, { params: toQuery(filters) });

// kind: signups | open_caseload | time_to_matter | converted | turned_down |
//       archived | in_progress | waiting | costs_advanced | costs_recovered |
//       costs_outstanding | costs_at_risk
// extra: { attorney, practice_area, month }
export const fetchDrill = (kind, filters, extra = {}) =>
  api.get(`${BASE}/drill/${kind}/`, { params: { ...toQuery(filters), ...extra } });
